var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
var CountDownTimer = function (props) {
    var timerProps = {
        isPlaying: true,
        size: 80,
        strokeWidth: 6,
    };
    return (React.createElement("div", { className: "d-flex align-items-center justify-content-center timerspan mgt-15" },
        React.createElement(CountdownCircleTimer, __assign({}, timerProps, { isPlaying: true, duration: props.duration ? props.duration : 120, colors: "#51B255", onComplete: function () { return console.log("times up"); }, onUpdate: function (rem) {
                props === null || props === void 0 ? void 0 : props.onTimerUpdate(rem);
            } }), function (_a) {
            var remainingTime = _a.remainingTime;
            return "" + Math.floor(remainingTime / 60) + ":" + (remainingTime % 60) + "";
        })));
};
export default CountDownTimer;
